<template>
  <div class="row">
    <div class="col-12 p-0 bg-white">
      <orders-list
        class="order-list"
        :orders="orders"
        :selected-status="selectedStatus"
        @select-order="onSelectOrder"
        @orders-updated="onOrdersUpdated"
      >
      </orders-list>
    </div>
  </div>
</template>

<script>
import api from '@/api.js'
import countBy from 'lodash/countBy'
// import StatusMenu from '@/components/transport/StatusMenu.vue'
import OrdersList from '@/components/transport/OrdersList.vue'
// import OrderDetail from '@/components/transport/OrderDetail.vue'
import find from 'lodash/find'

export default {

  components: {
    // StatusMenu,
    OrdersList,
    // OrderDetail
  },
 
  data() {
    return {
      ordersStore: [],
      statusesStore: []
    }
  },

  created: function() {
    api.get('/transport').then(res => {
      this.ordersStore = res.data.orders
    })

    api.get('/transport/statuses').then(res => {
      this.statusesStore = res.data.statuses
    })
  },

  computed: {
    orders() {
      if (!this.selectedStatus.id) {
        return this.ordersStore
      }
      return this.ordersStore.filter((order) => {
        if(order.status.id == this.selectedStatus.id) {
          return true
        }
      })
    },

    order() {
      return find(this.ordersStore, { id: parseInt(this.$route.params.id) }) || {}
    },

    selectedStatus() {
      return find(this.statusesStore, { slug: this.$route.params.status }) || {}
    },

    statuses() {
      const counts = countBy(this.ordersStore, 'status_id')
      
      return this.statusesStore.map(status => {
        status.ct = counts[status.id]
        status.active = status.id == this.selectedStatus.id
        return status
      })
    },
  },

  methods: {
    onOrdersUpdated() {
      api.get('/transport').then(res => {
        this.ordersStore = res.data.orders
      })

      api.get('/transport/statuses').then(res => {
        this.statusesStore = res.data.statuses
      })      
    },

    onSelectOrder(order) {
      this.orderStore = order
    },

    onSelectStatus(status) {
      this.selectedStatus = status
      this.onSelectOrder({})
    }
  },
}

</script>

<style scoped>
.order-list {
  height: calc(100vh - 48px);
  overflow-y: auto;
}

</style>